import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSaveSvg } from "./IconSaveSvg.mjs";
const IconSave = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSaveSvg, ...iconProps });
};
export {
  IconSave
};
